import { render, staticRenderFns } from "./swiperSchool.vue?vue&type=template&id=63083a1c&scoped=true&"
import script from "./swiperSchool.vue?vue&type=script&lang=js&"
export * from "./swiperSchool.vue?vue&type=script&lang=js&"
import style0 from "./swiperSchool.vue?vue&type=style&index=0&id=63083a1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63083a1c",
  null
  
)

export default component.exports